module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3e5189e4cd814b0d80c8ec6db1c31a4a.png";